var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero6"},[_c('client-only',[_c('v-sheet',{staticClass:"transparent"},[_c('auth-toolbar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }